import { createContext, useContext, useState } from "react";
import api from "../config/api";
import { toast } from "react-toastify";

export const DestinationContext = createContext();

export const DestinationProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [experienceLoading, setExperienceLoading] = useState(false);
  const [destinationsLoading, setDestinationsLoading] = useState(false);
  const [destinationData, setDestinationData] = useState([]);
  const [verifiedAdvisorsData, setVerifiedAdvisorsData] = useState([]);
  const [exprienceData, setExprienceData] = useState([]);
  const [durationSend,setDurationSend] = useState(null);

  const verifiedAdvisorList = async (request) => {
    setLoading(true);
    try {
      const response = await api.verifiedAdvisors.getVerifiedAdvisors(request);
      if (response?.success) {
        setVerifiedAdvisorsData(response?.data?.finalTopicList);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const discoverTopExpriences = async (request) => {
    setExperienceLoading(true);
    try {
      const response = await api.topExpriences.getTopExperiences(request);
      if (response?.success) {
        setExprienceData(response.data);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setExperienceLoading(false);
    }
  }

  const discoverTopDestinations = async (request) => {
    setDestinationsLoading(true);
    try {
      const response = await api.topDestination.getTopDestination(request);
      if (response?.success) {
        setDestinationData(response.data);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setDestinationsLoading(false);
    }
  }

  const contextValue = {
    loading,
    experienceLoading,
    destinationsLoading,
    destinationData,
    verifiedAdvisorList,
    verifiedAdvisorsData,
    discoverTopExpriences,
    exprienceData,
    discoverTopDestinations,
    durationSend,setDurationSend
  };
  return (
    <DestinationContext.Provider value={contextValue}>
      {children}
    </DestinationContext.Provider>
  );
};

export const useDestination = () => useContext(DestinationContext);
